<template>
  <div class="brand needResize" :class="{'fullscreen': fullscreen}" v-if="result">
    <Info @fullscreen="onFullScreen" title="brand.title" text="brand.info" ></Info>
    <div class="brand-title">
      <h3>{{$t('brand.title')}}</h3>
      <div class="metricSelector"> <v-select v-model="metricSelect" :options="metrics" :clearable="false" :searchable="false"></v-select></div>
      <div class="metricSelector"> <v-select v-model="topSelect" :options="tops" :clearable="false" :searchable="false"></v-select></div>
    </div>
    <div class="table-container">
      <div class="table">
        <div class="row header">
          <div class="cell header">
            {{$t('rank')}}
          </div>
          <div class="cell header">
            {{$t('brands')}}
          </div>
          <div class="cell header">
            {{getMetric.label}}
          </div>
          <div class="cell header">
            {{$t('percentage')}}
          </div>
        </div>
        <div class="row" v-for="(brand, index) in this.getItems" v-if="brand.key">
          <div class="cell rang" data-title="RANG">
            {{index + 1}}
          </div>
          <div class="cell" data-title="MARQUES">
            {{brand.key}}
          </div>
          <div class="cell" data-title="ARTICLES">
            {{brand[metricSelect.value].value | getKNumber | splitNumber}}
          </div>
          <div class="cell" data-title="POURCENTAGES">
            {{brand.percentage}}%
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Info from './Info.vue'
  export default {
    name: 'Brand',
    components: {
      Info
    },
    props: {
      result: Object,
      top:Object,
      metric:Object
    },
    data() {
      return {
        fullscreen: false,
        metrics: [
          {value:'amountPostDiscountTtc', label:'CA TTC (en €)'},
          {value:'profBrandHt', label:'Marge HT (en €)'},
          {value:'quantities', label:"Quantité (en nombre d'articles)"}
        ],
        tops: [
          {value: 10, label: "Top 10"},
          {value: 20, label: "Top 20"},
          {value: 30, label: "Top 30"},
          {value: 50, label: "Top 50"},
        ]
      }
    },
    mounted() {
      //this.cd_brand = this.buildHistogramData(response.data.aggregations.details.period.cd_brand.buckets, this.$t('message.soldProductsAmount'), getLabel, getQuantities)
    },
    computed: {
      getItems: function () {
        if (!this.result || !this.metricSelect || !this.result.aggregations || !this.result.aggregations['to-bills'] || !this.result.aggregations['to-bills'].bills || !this.result.aggregations['to-bills'].bills.details || !this.result.aggregations['to-bills'].bills.details['filtered-results'])
          return []
        else {
          let met = this.metricSelect;
          let sel = this.topSelect;
          let key = 'cd_brand_' + met.value;
          if (this.result.aggregations['to-bills'].bills.details['filtered-results'][key]) {
            return this.result.aggregations['to-bills'].bills.details['filtered-results'][key].buckets.slice(0, sel.value)
          } else {
            return []
          }
        }
      },
      getMetric: function() {
        return this.metric || {label:''}
      },
      topSelect: {
        get: function(){
          return this.top || this.tops[0];
        },
        set: function(evt){
          this.$emit('changeTop',evt)
        }
      },
      metricSelect: {
        get: function(){
          return this.metric || this.metrics[0];
        },
        set: function(evt){
          this.$emit('changeMetric',evt)
        }
      },
    },
    methods: {
      onFullScreen() {
        this.fullscreen = !this.fullscreen
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "@/assets/styles/components/brand.sass"
</style>
